import { Currency } from "@redotech/money/currencies";
import { getCurrencyFormatter } from "@redotech/money/util";
import { getApplicableStoreCredit } from "@redotech/redo-customer-portal-shared/utils/store-credit-notice";
import { T, useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const StoreCreditInvoiceNotice = memo(function StoreCreditInvoiceNotice({
  outstandingBalance,
  storeCreditBalance,
  currency,
}: {
  outstandingBalance: number;
  storeCreditBalance: number;
  currency: Currency;
}) {
  const { i18n } = useTranslation();
  const applicableStoreCredit = getApplicableStoreCredit({
    outstandingBalance,
    storeCreditBalance,
  });

  if (!applicableStoreCredit) {
    return null;
  }

  const amount = getCurrencyFormatter(
    currency,
    undefined,
    i18n.language,
  ).format(applicableStoreCredit);

  return (
    <Flex data-ui="store-credit-invoice-notice">
      <Text fontSize="sm" textColor="secondary">
        <T
          components={{
            bold: (
              <Text as="span" fontWeight="semibold">
                {null}
              </Text>
            ),
          }}
          defaults="You can apply your <bold>{{amount}}</bold> store credit toward this exchange on the final invoice sent after you submit your return."
          i18nKey="storeCreditInvoiceNotice"
          values={{ amount }}
        />
      </Text>
    </Flex>
  );
});
